var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
    },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            staticClass: "clearfix troubleshooting",
            attrs: { slot: "header", id: "device-troubleshooting" },
            slot: "header",
          },
          [
            _c("span", { staticClass: "header-item" }, [
              _vm._v("This account needs attention! "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-content" },
          [
            _c(
              "el-table",
              { staticStyle: { width: "100%" }, attrs: { data: _vm.data } },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "tag",
                    label: "Tag",
                    sortable: "",
                    width: "200",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            { staticStyle: { "word-break": "break-word" } },
                            [_vm._v(_vm._s(scope.row.display_name))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "Instruction" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("section", {
                            staticStyle: { "word-break": "normal" },
                            domProps: {
                              innerHTML: _vm._s(scope.row.instruction),
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }